export default {
  en: {
    'conversion-tool.tutorial.title': 'Conversion Tool',
    'conversion-tool.tutorial.do-not-show-again': "Don't show again",
    'conversion-tool.tutorial.got-it': 'Got it',
    'conversion-tool.tutorial.example': 'Example',
    'conversion-tool.tutorial.description': 'Use this tool to convert your spreadsheet data',
    'conversion-tool.tutorial.hint':
      'In a few quick steps you can map your data for use in {appName}.',
    'conversion-tool.tutorial.step': 'Step',
    'conversion-tool.tutorial.first-step.title': 'Upload',
    'conversion-tool.tutorial.first-step.description':
      'Upload your spreadsheet to start the process.',
    'conversion-tool.tutorial.second-step.title': 'Create mapping',
    'conversion-tool.tutorial.second-step.description':
      'Match your columns of data to the ones we use for {appName}. You can save the mapping to use again later.',
    'conversion-tool.tutorial.second-step.items-count': 'Sheets found',
    'conversion-tool.tutorial.second-step.item-count': 'Sheet found',
    'conversion-tool.tutorial.third-step.title': 'Convert',
    'conversion-tool.tutorial.third-step.description':
      'This will convert your data into the format we use for processing.',
    'conversion-tool.tutorial.fourth-step.title': 'Process data',
    'conversion-tool.tutorial.fourth-step.description':
      'Once converted your data will be ready to process.',
  },
};
